import React from "react";
import { Box, Typography, Grid, Card, CardContent, Button } from "@mui/material";

const pricingTiers = [
  {
    name: "Starter",
    price: "$4.99",
    description: "Free for everyone",
    features: [
      "Manual CSV uploads (10,000 rows/month)",
      "Basic dashboards and reports",
      "3 months of data history",
    ],
    buttonText: "Get Started",
    buttonVariant: "contained",
  },
  {
    name: "Growth",
    price: "$14.99/month",
    description: "$9.99/month if billed annually",
    features: [
      "3 integrations (Shopify, Meta Ads, Google Ads)",
      "Unlimited CSV uploads",
      "Advanced dashboards and analytics",
      "12 months of data history",
      "API key integrations",
    ],
    buttonText: "Get Started",
    buttonVariant: "contained",
  },
  {
    name: "Enterprise",
    price: "49.99/month",
    description: "Annual billing only",
    features: [
      "All Growth features",
      "Dedicated account manager",
      "Custom API integrations",
      "SAML and SCIM support",
      "Advanced security",
      "Custom onboarding and migration",
    ],
    buttonText: "Request Trial",
    buttonVariant: "outlined",
  },
];

const PricingPage = () => {
  return (
    <Box sx={{ padding: 4, backgroundColor: "#121212", color: "white", minHeight: "100vh" }}>
      <Typography variant="h3" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
        Pricing Plans
      </Typography>
      <Typography variant="subtitle1" align="center" sx={{ mb: 4, color: "rgba(255, 255, 255, 0.7)" }}>
        Choose the plan that fits your needs and start managing your data with ease.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {pricingTiers.map((tier, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                backgroundColor: "#1c1c1c",
                borderRadius: 2,
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                border: index === 1 ? "2px solid #4caf50" : "1px solid rgba(255, 255, 255, 0.1)",
                height: "100%",
              }}
            >
              <CardContent sx={{ padding: 3 }}>
                <Typography
                  variant="h5"
                  align="center"
                  sx={{ fontWeight: "bold", color: "white", mb: 2 }}
                >
                  {tier.name}
                </Typography>
                <Typography
                  variant="h4"
                  align="center"
                  sx={{ color: index === 3 ? "#ff9800" : "#4caf50", mb: 1 }}
                >
                  {tier.price}
                </Typography>
                <Typography
                  variant="body2"
                  align="center"
                  sx={{ mb: 3, color: "rgba(255, 255, 255, 0.7)" }}
                >
                  {tier.description}
                </Typography>
                <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                  {tier.features.map((feature, i) => (
                    <li key={i}>
                      <Typography variant="body2" sx={{ mb: 1, color: "rgba(255, 255, 255, 0.9)" }}>
                        ✅ {feature}
                      </Typography>
                    </li>
                  ))}
                </ul>
                <Box sx={{ mt: 3, textAlign: "center" }}>
                  <Button
                    variant={tier.buttonVariant}
                    color="primary"
                    size="large"
                    sx={{
                      width: "100%",
                      maxWidth: "200px",
                      backgroundColor: index === 3 ? "transparent" : "#4caf50",
                      borderColor: index === 3 ? "#ff9800" : "transparent",
                      color: index === 3 ? "#ff9800" : "white",
                      "&:hover": {
                        backgroundColor: index === 3 ? "rgba(255, 255, 255, 0.1)" : "#45a049",
                      },
                    }}
                  >
                    {tier.buttonText}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PricingPage;
